<div dir="rtl" class="tab-hub">
  <nz-page-header-title *ngIf="title">{{ title }}</nz-page-header-title>

  <nz-tabset nzType="card" class="tab-hub-tabs" [nzSelectedIndex]="selectedIndex"
    (nzSelectChange)="onTabChange($event)">
    <nz-tab *ngFor="let tab of tabs" [nzTitle]="tab.label"></nz-tab>
  </nz-tabset>

  <router-outlet></router-outlet>
</div>
